import {
  START_RECORDING_DATA,
  STOP_RECORDING_DATA,
} from "./record-video.actionTypes";

const initialState = {
  recordData: {},
};

export default function record(state = initialState, action: any) {
  switch (action.type) {
    case START_RECORDING_DATA: {
      return {
        ...state,
        recordData: action.payload,
      };
    }
    case STOP_RECORDING_DATA: {
      return {
        ...state,
        recordData: action.payload,
      };
    }
    default:
      return state;
  }
}
